import { render, staticRenderFns } from "./contact-list-header.vue?vue&type=template&id=0c9332b5"
import script from "./contact-list-header.vue?vue&type=script&lang=js"
export * from "./contact-list-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports